import React from "react";

type Props = {
  checked: boolean;
  ariaLabel?: string;
  size?: "small" | "medium" | "large";
};

const CustomCheckbox: React.FC<Props> = ({
  checked,
  ariaLabel,
  size = "small",
}) => {
  const width = size === "small" ? 20 : size === "large" ? 40 : 30;
  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel}
      className={"CustomCheckbox "}
      style={{
        // only expand vertically: take full available height, compute width from height
        height: `${width}px`,
        width: "auto",
        maxWidth: "100%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        margin: "0 15px 0 0",
      }}
    >
      <div
        style={{
          // keep the checkbox perfectly square based on the available height
          height: "100%",
          width: "auto",
          aspectRatio: "1 / 1",
          boxSizing: "border-box",
          border: "2px solid currentColor",
          borderRadius: 6,
          background: "#ffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <svg
          viewBox="0 0 24 24"
          width="100%"
          height="100%"
          aria-hidden
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 7L11 17 5.5 12"
            fill="none"
            stroke={checked ? "#000000FF" : "none"}
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default CustomCheckbox;
